import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router";

import { AppContext } from "../../AppProvider";

const PracticeArea = () => {
  const [loading, setLoading] = useState(true);
  const { uri } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${uri}practice-areas/`)
      .then((response) => {
        setCardData(response.data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <span className="loading loading-bars loading-lg"></span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Error: {error}</p>
      </div>
    );
  }

  return (
   
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 justify-items-center px-4">
    {cardData.map((card) => (
      <Link key={card.id} to={`/practice-areas/${card.id}`}>
        <div className="min-h-[12rem] min-w-[12rem] max-h-[20rem] max-w-[20rem] relative overflow-hidden rounded-lg shadow-lg group">
          <img
            src={card.image}
            alt={card.name}
            className="object-cover h-full w-full transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full bg-black bg-opacity-50 text-white p-4">
            <h2 className="text-lg font-semibold text-center">
              {card.name.length > 40 ? card.name.substring(0, 40) + "..." : card.name}
            </h2>
            <button className="h-12 px-4 py-2 mt-6 text-black bg-white border rounded-2xl hover:shadow-lg">
              View Details
            </button>
          </div>
        </div>
      </Link>
    ))}
  </div>
  
  );
};

export default PracticeArea;
